import React, { useState, useEffect } from "react";
import {
  HTTP_METHODS,
  invokeApi,
  plainApi,
} from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
import { toast } from "react-toastify";
import { Box, IconButton } from "@mui/material";
import { HeaderConfig, BenchMarkingHeaderConfig } from "./config";
import CustomButtonComponent from "../../../../core/custom-button";
import CustomTable from "../../../../core/custom-table";
import BenchFilters from "./bench-marking-filters";
import { exportToExcel, PAGE_LIMIT } from "../../../../utils";
// import ClaimsFilters from "../../oem/claims/claims-filters";

const BenchMarking = () => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({
    page: 1,
    limit: PAGE_LIMIT,
  });

  const downloadReports = () => {
    const params = {
      page: 1,
      limit: data?.totalResults || 100,
    };
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.BENCH_MARKING}`,
      null,
      params
    )
      .then((res) => {
        if (!res.message) {
          const formattedData = res?.results?.map(
            ({ id, archive, ...rest }) => {
              const transformed = {};
              for (const [key, value] of Object.entries(rest)) {
                // Convert camelCase to Capitalized Headers
                const header = key
                  .replace(/([a-z])([A-Z])/g, "$1 $2")
                  .replace(/^./, (str) => str.toUpperCase());
                // Special handling for coreFeatures
                transformed[header] =
                  key === "coreFeatures" && Array.isArray(value)
                    ? value.join(", ")
                    : value;
              }
              return transformed;
            }
          );

          exportToExcel(formattedData, "Benchmarking");
        }
      })
      .catch((err) => console.error(err));
  };

  const loadData = (filters) => {
    const payload = { ...filters };
    setIsLoading(true);
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.BENCH_MARKING}`,
      null,
      payload
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          setData(res);
        }
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    loadData(filters);
  }, []);
  return (
    <div className="page-body">
      <div className=" view-detailed-ticket">
        <div>
          <p className="tab-name">Analysis</p>
          <p className="section-name">View Benchmarking</p>
        </div>
      </div>
      <div>
        {data?.results?.length > 0 && (
          <div className="create-con">
            <p className="primary-text">Benchmarking Report</p>
            <Box sx={{ display: "flex", gridGap: "20px" }}>
              <CustomButtonComponent
                variant="contained"
                color="success"
                onClick={downloadReports}
              >
                Download Report
              </CustomButtonComponent>
            </Box>
          </div>
        )}

        <div className="si-hide-mobile">
          <CustomTable
            header={BenchMarkingHeaderConfig}
            data={data.results || []}
            pageCount={data.totalPages}
            filters={filters}
            onChange={(page) => {
              setFilters({
                ...filters,
                page,
              });
              loadData({
                ...filters,
                page,
              });
            }}
            // filterCom={<BenchFilters loadData={loadData} />}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  );
};
export default BenchMarking;
